import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";
import api from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export const ReviewStrip = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reviews").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.reviews.length) return null;
  const top = [...data.reviews]
    .sort((a, b) => b.rating - a.rating || b.body.length - a.body.length)
    .slice(0, 2);

  return (
    <section className="border-y border-slate-200 bg-white py-20 sm:py-24" data-testid="review-strip">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-royal">
                Neighbors talking
              </p>
              <h2 className="mt-3 font-display text-2xl font-extrabold tracking-tight text-ink sm:text-3xl">
                {data.average} stars across {data.count} Central Oregon moves
              </h2>
            </div>
            <Link
              to="/reviews"
              data-testid="review-strip-link"
              className="group flex items-center gap-2 text-sm font-bold text-royal"
            >
              Read all reviews
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {top.map((r, i) => (
            <Reveal key={r.id} delay={0.1 + i * 0.1}>
              <figure className="flex h-full flex-col rounded-3xl border border-slate-200 bg-paper p-8 transition-all duration-300 hover:border-royal/40 hover:shadow-xl hover:shadow-royal/5" data-testid={`review-strip-card-${r.id}`}>
                <span className="flex items-center gap-2">
                  <span className="flex items-center gap-0.5">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <Star key={n} className={`h-4 w-4 ${n <= r.rating ? "fill-gold text-gold" : "text-slate-300"}`} />
                    ))}
                  </span>
                  {r.repeat_customer && (
                    <span data-testid={`repeat-badge-strip-${r.id}`} className="inline-flex items-center gap-1 rounded-full bg-gold/15 px-2 py-0.5 font-mono text-[9px] font-bold uppercase tracking-[0.12em] text-amber-700">
                      <Star className="h-2.5 w-2.5 fill-gold text-gold" /> Repeat customer
                    </span>
                  )}
                </span>
                <blockquote className="mt-4 flex-1 font-serif text-lg italic leading-relaxed text-ink">
                  "{r.body}"
                </blockquote>
                <figcaption className="mt-5 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-royal">
                  — {r.name}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
